import { useCallback } from 'react';

import { useDeleteUserAccount } from 'core/Api';
import { getErrorMessage_v2 } from 'core/Utils';
import { useNavigate } from 'react-router-dom';
import { Alert, ButtonMantine, FullWidthButtonGroup, Modal, Stack, notifications } from 'ui';

import { useLogoutUser } from '../../../hooks/useLogoutUser';

const DeleteAccountContent = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate();
  const { mutate: deleteAccount } = useDeleteUserAccount();
  const { userLogout } = useLogoutUser();
  const handleDelete = useCallback(() => {
    deleteAccount(undefined, {
      onSuccess: () => {
        notifications.show({ message: 'Account successfully deleted', variant: 'success' });
        userLogout({ callBack: () => navigate('/') });
      },
      onError: (error) => {
        notifications.show({ message: getErrorMessage_v2(error), variant: 'error' });
      },
    });
  }, [deleteAccount, userLogout, navigate]);

  return (
    <Stack gap="xl">
      <Alert title="Delete your account?" type="error">
        Deleting your account will permanently remove all your data, information, and any available
        cashback. This action can’t be undone.
      </Alert>
      <FullWidthButtonGroup>
        <ButtonMantine onClick={() => onClose()} variant="subtle">
          Cancel
        </ButtonMantine>
        <ButtonMantine onClick={handleDelete} color="cerise">
          Delete Account
        </ButtonMantine>
      </FullWidthButtonGroup>
    </Stack>
  );
};

const DeleteAccountModal = ({ opened, onClose }: { opened: boolean; onClose: () => void }) => {
  return (
    <Modal opened={opened} onClose={onClose} title="Delete Account">
      <DeleteAccountContent onClose={onClose} />
    </Modal>
  );
};

export { DeleteAccountModal };
